import React, { useState, useEffect } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = (prop) => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const [openDesktopSubmenuId, setOpenDesktopSubmenuId] = useState(null);

    useEffect(() => {
        const resetDesktopSubmenu = () => setOpenDesktopSubmenuId(null);
        window.addEventListener('navbar-close-all', resetDesktopSubmenu);
        return () =>
            window.removeEventListener('navbar-close-all', resetDesktopSubmenu);
    }, []);

    return (
        <NavigationItem
            links={contentLinks}
            values={prop.values}
            menuDepth={0}
            openDesktopSubmenuId={openDesktopSubmenuId}
            setOpenDesktopSubmenuId={setOpenDesktopSubmenuId}
        />
    );
};

export default Navigation;
